<template>
  <v-container grid-list-xl fluid>
    <v-card>
      <v-card-text>
        <v-layout row wrap>
          <v-flex sm2>
            <v-btn class="mb-2" outline @click="goBack">
              <v-icon class="iconText">fa fa-angle-left</v-icon>
              &nbsp;&nbsp;Back
            </v-btn>
          </v-flex>
          <v-flex sm10>
            <div class="headline green--text text--darken-4 font-weight-medium">
              Create New Prescription
            </div>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <v-divider></v-divider>
            <br />
            <sm-p :patient="patient"></sm-p>
            <br />
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <sm-spt
              :spt="spt"
              :patient="patient"
              v-on:updateSpt="updateSpt"
            ></sm-spt>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <sm-pr
              :patient="patient"
              :spt="spt"
              :prescription="prescription"
              v-on:clearFields="clearFields"
            ></sm-pr>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import WebH from "../../api/web";
import SmP from "../../components/patient/SmPatient";
import SmSpt from "../../components/spts/SmallSpt";
import SmPr from "../../components/prescription/SmallPr";
export default {
  props: ["patient"],
  components: {
    SmP,
    SmSpt,
    SmPr
  },
  created() {
    //this.api_getDoc();
    if (this.patient) this.api_loadData();
  },
  data() {
    return {
      loading: false,
      //doc: {},
      spt: {},
      prescription: {}
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    clearFields() {
      this.spt = {};
      this.prescription = {};
    },
    updateSpt(spt) {
      this.spt = spt;
    },
    async api_loadData() {
      this.loading = true;
      this.spt = {};
      this.prescription = {};
      await this.api_getSpt(this.patient.Id);
      await this.api_getLastPayment(this.patient.Id);
      this.loading = false;
    },
    async api_getDoc() {
      let url = "/doctors/csd";
      const res = await WebH.Get(url, "doctor");
      if (res.Success) this.doc = res.Data;
    },
    async api_getSpt(id) {
      const url = "/spts/latest/" + id;
      const res = await WebH.Get(url, "latest spt");
      if (res.Success) {
        if (res.Data !== "") this.spt = res.Data;
      }
    },
    async api_getLastPayment(id) {
      const res = await WebH.Get("/prescriptions/lpmt/" + id, "last payment");
      if (res.Success) {
        if (res.Data !== "") this.prescription = res.Data;
      }
    }
  }
};
</script>

<style scoped></style>
